// Clinic Configuration for Reno Dental care and Orthodontics
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Reno Dental care and Orthodontics",
  clinicId: "renodentalcareandorthodontics",
  clinicUrl: "https://renodentalcareandorthodontics.com",
  // Contact Information
  phoneNumber: "775-339-9893",
  phoneNumberRaw: "+17753399893", // For tel: and sms: links
  email: "dentalcare@renodentalcareandorthodontics.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=renodentalcareandorthodontics&agentId=07d4b38c-ccd1-4015-a904-1e3602529563",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/renodentalcareandorthodontics/voice",

  // Location
  address: "8040 S Virginia St, Suite 1 , Reno, NV 89511",
  addressShort: "8040 S Virginia St, Suite 1, Reno, NV 89511",
  city: "Reno",
  hcity: "Reno",
  state: "Nevada",
  stateShortForm: "NV",
  PostalCode: "89511",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/XWwTxKnmGrJHeUXP8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d89182.56021793869!2d-119.90964641044987!3d39.476432399468486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80991550964234f1%3A0x3eeb300007556969!2sDentist%20in%20Reno!5e1!3m2!1sen!2sin!4v1770214193168!5m2!1sen!2sin',
  iframeTitle: "Reno Dental care and Orthodontics",

  //membership
  membership: "https://member.kleer.com/?slug=ZV6U",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinReno",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/reno-dental-care-and-ortho?utm_source=practice&utm_medium=email&m=66192",


  // Analytics
  clarityProjectId: "tetwfq1mjm",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/renodentalcareandorthodontics",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/renodentalcareandorthodontics",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/renodentalcareandorthodontics",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/RenoDentalCareandOrthodontics",
    instagram: "https://www.instagram.com/reno_dental_care/",
    twitter: "https://x.com/Reno_DentalCare",
    linkedin: "https://www.linkedin.com/company/dentist-in-reno/",
    youtube: "https://www.youtube.com/@RenoDentalcare",
  },

  // Open Dental Configuration
  defaultProvNum: 3607,
  defaultOpNum: 50,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 51,
      AppointmentTypeNum: 6,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 50, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 50, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

